function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Icon/Big/NoSun"
}, React.createElement("path", {
  id: "Combined Shape",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M57.4277 50.1788L55.7817 49.0438C58.7977 44.6678 60.3917 39.5328 60.3917 34.1968C60.3917 19.7518 48.6407 7.99976 34.1957 7.99976C29.3267 7.99976 24.5747 9.34476 20.4537 11.8898L19.4027 10.1878C23.8397 7.44876 28.9557 5.99976 34.1957 5.99976C49.7427 5.99976 62.3917 18.6488 62.3917 34.1968C62.3917 39.9408 60.6757 45.4678 57.4277 50.1788ZM34.1958 62.3922C18.6488 62.3922 5.99982 49.7442 5.99982 34.1962C5.99982 28.6172 7.62682 23.2222 10.7048 18.5962L12.3698 19.7042C9.51082 24.0002 7.99982 29.0122 7.99982 34.1962C7.99982 48.6412 19.7518 60.3922 34.1958 60.3922C39.6668 60.3922 44.9058 58.7242 49.3498 55.5672L50.5078 57.1982C45.7248 60.5962 40.0838 62.3922 34.1958 62.3922ZM59.7959 61.2105C59.9909 61.4055 60.2469 61.5035 60.5029 61.5035C60.7589 61.5035 61.0149 61.4055 61.2099 61.2105C61.6009 60.8195 61.6009 60.1875 61.2099 59.7965L8.59592 7.18246C8.20492 6.79146 7.57192 6.79146 7.18192 7.18246C6.79092 7.57246 6.79092 8.20546 7.18192 8.59646L59.7959 61.2105Z",
  fill: "#6E6E6E"
}));

var SvgNoSun = function SvgNoSun(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 69,
    height: 68,
    viewBox: "0 0 69 68",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNoSun, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no-sun.97335604.svg";
export { ForwardRef as ReactComponent };